import React from 'react';
import { CreditCardIcon, MailIcon, FileTextIcon, PrinterIcon, SmileIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: CreditCardIcon,
    title: 'Comprás el kit',
    desc: 'Pago único, 100% seguro.'
  }, {
    icon: MailIcon,
    title: 'Lo recibís por email',
    desc: 'Acceso inmediato tras el pago.'
  }, {
    icon: FileTextIcon,
    title: 'Abrís el PDF',
    desc: 'Desde cualquier dispositivo.'
  }, {
    icon: PrinterIcon,
    title: 'Imprimís y preparás',
    desc: 'Solo lo que vas a usar hoy.'
  }, {
    icon: SmileIcon,
    title: 'Jugás con tu hijo',
    desc: 'En menos de 5 minutos.'
  }];
  return <section className="bg-brand-cream-50/60 px-5 py-10 sm:py-12" data-id="element-131">
      <div className="max-w-2xl mx-auto" data-id="element-132">
        <div className="text-center mb-8" data-id="element-133">
          <p className="text-xs uppercase tracking-wider text-brand-green-600 font-bold mb-3" data-id="element-134">
            Cómo funciona
          </p>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-135">
            Tan simple como esto
          </h2>
        </div>

        <ol className="space-y-4" data-id="element-136">
          {steps.map(({
          icon: Icon,
          title,
          desc
        }, idx) => <li key={title} className="flex items-center gap-4 bg-white rounded-2xl p-4 border border-slate-100 shadow-soft" data-id="element-137">
              <div className="relative shrink-0" data-id="element-138">
                <div className="w-12 h-12 rounded-xl bg-brand-green-500 flex items-center justify-center" data-id="element-139">
                  <Icon className="w-5 h-5 text-white" data-id="element-140" />
                </div>
                <div className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-brand-cream-300 rounded-full flex items-center justify-center text-[10px] font-bold text-brand-ink" data-id="element-141">
                  {idx + 1}
                </div>
              </div>
              <div data-id="element-142">
                <h3 className="font-bold text-brand-ink" data-id="element-143">{title}</h3>
                <p className="text-sm text-slate-500" data-id="element-144">{desc}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}